export default "__VITE_ASSET__BXswoUBN__"